import React from 'react';
import '../../App.css';
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer mt-auto">
      <p>© 2025 UNIVERSIDAD ESPE. TODOS LOS DERECHOS RESERVADOS.</p>
      <div className="socials">
        <a href="https://www.facebook.com/nafespe2023" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="http://www.instagram.com/nafespe" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://www.tiktok.com/@nafespe?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-tiktok"></i>
        </a>
        <Link to="/politica-privacidad" className="text-sm underline text-green-700 hover:text-green-900">
          Política de Privacidad
        </Link>
        <Link to="/politica-cookies" className="text-sm underline text-green-700 hover:text-green-900">
          Política de Cookies
        </Link>
        <Link to="/terminos-condiciones" className="text-sm underline text-green-700 hover:text-green-900">
          Términos y Condiciones
        </Link>
      </div>
    </footer>
  );
}

export default Footer;
